import {gql} from '@apollo/client';
import {AddComplaintOrgMemberInput} from './types';

export const ADD_COMPLAINT_ORG_MEMBER = gql`
    mutation AddComplaintOrgMember($input: AddComplaintOrgMemberInput!) {
        addComplaintOrgMember(input: $input)
    }
`;

export interface AddComplaintOrgMemberResponse {
  addComplaintOrgMember: number;
}

export interface AddComplaintOrgMemberVariables {
  input: AddComplaintOrgMemberInput;
}

export const REMOVE_COMPLAINT_ORG_MEMBER = gql`
    mutation RemoveComplaintOrgMember($memberId: Long!) {
        removeComplaintOrgMember(memberId: $memberId)
    }
`;

export interface RemoveComplaintOrgMemberResponse {
  removeComplaintOrgMember: boolean;
}
